import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Dashboard, DashboardsStore } from '@fry/dashboards/lib';

@Injectable()
export class DashboardResolver  {

    constructor(private store: DashboardsStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Dashboard> {
        const id = route.paramMap.get('dashboardID');
        return this.store.getForEdit(id);
    }
}
